import script from "./DomainManagementReputation.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainManagementReputation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__